import { render, staticRenderFns } from "./kamitakuFlowRole.vue?vue&type=template&id=5ab55909&scoped=true&"
import script from "./kamitakuFlowRole.vue?vue&type=script&lang=js&"
export * from "./kamitakuFlowRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab55909",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab55909')) {
      api.createRecord('5ab55909', component.options)
    } else {
      api.reload('5ab55909', component.options)
    }
    module.hot.accept("./kamitakuFlowRole.vue?vue&type=template&id=5ab55909&scoped=true&", function () {
      api.rerender('5ab55909', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kamitaku/kamitakuFlowRole.vue"
export default component.exports